import swal from "sweetalert"
import { sendAction } from "shared/djangio/action-creators"
import * as profileActionDicts from "shared/profiles/press-contact/press-contact-profile-action-types"
import { requestChangesOfficialsAndStaffers as swalConfig } from "app/static/frontend/profiles-new/constants/swalConfigs"

export const requestChanges = (profileId) => (dispatch) => {
    swal(swalConfig).then((input) => {
        if (input === null) {
            return
        }
        if (!input) {
            swal("Error", "You did not submit an explanation. Please explain what is incorrect.", "error")
            return
        }

        dispatch(
            sendAction(DjangIO.app.person.models.Person, profileActionDicts.postRequestChangesPressContactActionDict, {
                action: "report_incorrect",
                kwargs: {
                    id: profileId,
                    message: input,
                },
                method: "post",
            }),
        )
            .then(() => {
                swal("Thanks!", "We've sent it along.", "success")
            })
            .catch(() => {
                swal(
                    "Sorry",
                    "Something went wrong. Please try again, or send an email to report@quorum.us.",
                    "warning",
                )
            })
    })
}
